import type { FormControlModelExtended, SuggestedAnswerModelExtended } from './types';
import type { FormControlModel } from '@generated';
import type { FormValues } from '~/shared/forms/types';
import { satisfiesWhenCondition } from './when';

export function suggestOptions(formControls: FormControlModel[], formValues: FormValues): FormControlModelExtended[] {
	return formControls.map((control: FormControlModel) => {
		if (control.hidden) {
			return control as FormControlModelExtended;
		}

		if (control.formControls) {
			control.formControls = suggestOptions(control.formControls, formValues);
		}

		if (!control.options || control.options.length === 0) {
			return control as FormControlModelExtended;
		}

		for (const option of control.options.filter(x => !x.hidden)) {
			if (option.formControls) {
				option.formControls = suggestOptions(option.formControls, formValues);
			}
			if (option.suggestedAnswer && option.suggestedAnswer.length > 0) {
				option.suggestedAnswer = option.suggestedAnswer.map(suggestedAnswer => {
					const when = suggestedAnswer.when.map(when => ({
						...when,
						isSatisified: satisfiesWhenCondition(when, formValues)
					}));
					return {
						...suggestedAnswer,
						when: when
					};
				}) as SuggestedAnswerModelExtended[];
			}
		}

		return control as FormControlModelExtended;
	});
}
